import React from 'react';
import logo from '../../assets/images/opt-6.jpg';
import { motion } from 'framer-motion';
// calendar icon 
import { FaCalendarAlt, FaPhoneAlt } from 'react-icons/fa';

const Hero = () => {
  const handleScrollToForm = () => {
    const formElement = document.getElementById('transfer-form');
    if (formElement) {
      formElement.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="relative w-full h-screen flex items-center justify-center">
      {/* Background image with overlay */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{ 
          backgroundImage: `url(${logo})`,
          backgroundPosition: 'center',
        }}
      >
        <div className="absolute inset-0 bg-black/50"></div>
      </div>

      {/* Hero content */}
      <div className="container mx-auto px-4 relative z-10 sm:mt-0 mt-40">
        <motion.div 
          className="max-w-xl mx-auto bg-black/40 backdrop-blur-sm p-10 rounded-lg"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <motion.h1 
            className="text-white text-4xl md:text-5xl lg:text-6xl font-bold text-center mb-4"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            MYKONOS TRANSFER
          </motion.h1>
          <motion.h2 
            className="text-white text-2xl md:text-3xl lg:text-4xl font-semibold text-center mb-8"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
          >
            Anywhere and Anytime
          </motion.h2>
          <motion.p 
            className="text-white text-lg md:text-xl text-center mb-8"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.6 }}
          >
            In Just 2 Simple Clicks
          </motion.p>

          <motion.div 
            className="w-full h-px bg-white/50 mb-8"
            initial={{ scaleX: 0 }}
            animate={{ scaleX: 1 }}
            transition={{ duration: 1, delay: 0.8 }}
          />

          <motion.div 
            className="flex flex-col md:flex-row gap-6 justify-center"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 1 }}
          >
            <motion.button
              onClick={handleScrollToForm}
              className="px-8 py-3 bg-transparent border-2 border-primary-light text-white font-medium rounded hover:bg-primary-light transition-all duration-300"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              <FaCalendarAlt className="inline-block mr-2" />
              Make Booking
            </motion.button>
            <motion.a
              href="tel:+306941419012"
              className="px-8 py-3 bg-transparent border-2 border-primary-light text-white font-medium rounded hover:bg-primary-light transition-all duration-300 text-center"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              <FaPhoneAlt className="inline-block mr-2" />
              Call Us Now
            </motion.a>
          </motion.div>
        </motion.div>
      </div>
    </div>
  );
};

export default Hero;
